import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { ProjectInterface } from "../../../middleware/interfaces/project/project-interface";

export const ProjectCreate = {
  Create: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const projectCreateData: ProjectInterface = state.data;
      const url = "./php/project/project-creator-proxy.php";
      await axios
        .post(url, projectCreateData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
